import React from 'react';
import { PageSection } from '../PageSection';
import { CtaButton } from '../CtaButton';
import { CheckItem } from '../CheckItem';
import { ProductImage } from '../ProductImage';
import { PriceBlock } from '../PriceBlock';
import { PRODUCT_NAME, offerIncludes } from '../../data/salesContent';
export function OfferSection() {
  return <PageSection id="oferta" labelledBy="offer-title" data-id="element-133" data-mp="ai9zaaw9tav0">
      <div className="rounded-3xl border-2 border-cyan-500 bg-slate-950 p-6 text-center md:p-10" data-id="element-134" data-mp="6gyag7l80tnv">
        <p className="font-display text-sm font-extrabold uppercase tracking-[0.3em] text-cyan-400" data-id="element-135" data-mp="1qrhxwnl8p0c">Oferta especial</p>
        <h2 id="offer-title" className="mt-3 font-display text-2xl font-extrabold uppercase leading-tight text-white md:text-[2rem]" data-id="element-136" data-mp="3svznf7kbyz5f">
          {PRODUCT_NAME}
        </h2>
        <p className="mx-auto mt-3 max-w-md text-base font-semibold uppercase leading-snug text-zinc-300" data-id="element-137" data-mp="3iyd9anauvbmi">
          El sistema visual completo para entender y cuidar mejor tu vehículo
        </p>
        <ProductImage className="mx-auto mt-6 w-full max-w-md" data-id="element-138" data-mp="1asaejutc3y7r" />
        <div className="mt-6 font-display text-lg font-extrabold uppercase leading-snug md:text-xl" data-id="element-139" data-mp="1aqpke6axmhaf">
          <p className="text-white" data-id="element-140" data-mp="1fk1yhmhzj5ox">4 volúmenes completos</p>
          <p className="text-cyan-400" data-id="element-141" data-mp="10uvyhwbbpbfz">+ 5 bonos prácticos</p>
        </div>
        <ul className="mx-auto mt-6 max-w-md space-y-3 text-left text-base font-medium text-zinc-100 md:text-[17px]" data-id="element-142" data-mp="15snzdfty47wb">
          {offerIncludes.map(item => <CheckItem key={item} data-id="element-143" data-mp="1tj1i2fqn4ue8">{item}</CheckItem>)}
        </ul>
        <div className="mx-auto my-8 h-px max-w-md bg-zinc-800" aria-hidden="true" data-id="element-144" data-mp="1yi4mpz2pkylo" />
        <PriceBlock lead="Hoy por" notes={['Pago único', 'Acceso digital inmediato']} data-id="element-145" data-mp="1ki3nsp60818u" />
        <div className="mt-7" data-id="element-146" data-mp="1ojf4u6atbe5f">
          <CtaButton data-id="element-147" data-mp="1oinlpuyej8w1">Quiero mi Kit Mantenimiento Total del Auto</CtaButton>
        </div>
      </div>
    </PageSection>;
}